import { useCallback, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

import { useClient } from "../../hook/useClient";
import { useClientInfo } from "../../hook/useClientInfo";
import PageIntro from "../../components/ui/PageIntro";
import OriginsPanel from "./OriginsPanel";

/**
 * Where the discussion may appear.
 *
 * The one setting that fails silently: a domain missing from this list is
 * refused by the BROWSER (frame-ancestors), so the widget simply does not
 * render there and nothing on the customer's page says why.
 *
 * Beside the list (2026-10-22): the rest of the system's settings, read-only,
 * because only MySuhbat staff change them -- shown so a customer can see what
 * they are without having to ask.
 */
const OriginsPage = () => {
  const { clientId, canManage } = useClient();
  const info = useClientInfo();
  const [count, setCount] = useState(null);
  const onCount = useCallback((n) => setCount(n), []);

  const ticket = info?.auth_mode === "ticket";

  return (
    <>
      <PageIntro
        icon="tabler:world"
        title="Ruxsat etilgan domenlar"
        readOnly={!canManage}
        chips={
          count === null
            ? []
            : [
                count
                  ? { icon: "tabler:world-check", label: `${count} ta domen`, tone: "good" }
                  : { icon: "tabler:world-off", label: "Domen yoʻq — vidjet koʻrinmaydi", tone: "warn" },
              ]
        }
      >
        Muhokama faqat shu yerda ruxsat berilgan manzillarda koʻrinadi. U ishlaydigan har bir
        domenni — test (staging) muhitini ham — qoʻshing, aks holda brauzer uni koʻrsatmaydi va
        sahifada hech qanday xato chiqmaydi.
      </PageIntro>

      <div className="ms-recordgrid ms-recordgrid--list-side">
        <OriginsPanel clientId={clientId} canEdit={canManage} onCount={onCount} />

        <div className="ms-panel">
          <div className="ms-panel-head">
            <Icon icon="tabler:settings" />
            <h2>Tizim sozlamalari</h2>
          </div>
          <dl className="ms-facts">
            <div>
              <dt>Tizim nomi</dt>
              <dd>{info?.name || "—"}</dd>
            </div>
            <div>
              <dt>Slug (vidjet kodi)</dt>
              <dd className="ms-mono">{info?.slug || "—"}</dd>
            </div>
            <div>
              <dt>Kirish usuli</dt>
              <dd>{info ? (ticket ? "Sayt logini (ticket)" : "QR (telefon)") : "—"}</dd>
            </div>
            <div>
              <dt>Faol API kalitlari</dt>
              <dd>
                {info ? (
                  info.credential_count ? (
                    info.credential_count
                  ) : (
                    <span className="ms-badge ms-badge--danger">yoʻq</span>
                  )
                ) : (
                  "—"
                )}
              </dd>
            </div>
            <div>
              <dt>Holati</dt>
              <dd>
                {info && (
                  <span className={`ms-badge ms-badge--${info.is_active ? "success" : "danger"}`}>
                    {info.is_active ? "Faol" : "Oʻchirilgan"}
                  </span>
                )}
              </dd>
            </div>
          </dl>
          <p className="ms-panel-note">
            Bularni MySuhbat jamoasi boshqaradi. Nomni, kirish usulini yoki API kalitini
            oʻzgartirish kerak boʻlsa, biz bilan bogʻlaning.
          </p>
        </div>
      </div>
    </>
  );
};

export default OriginsPage;
